<template>
  <div>
    <div class="box">
      <p class="title is-3-desktop is-4-tablet is-5-mobile center">
        Reporte Estado de Materiales
      </p>

      <article class="media"></article>
      <div class="media-content">
        <div class="content">
          <div class="columns">
            <div class="column">
              <b-field label="Desde">
                <b-datepicker
                  v-model="dateFrom"
                  placeholder="Ingresa el primer rango"
                  icon="calendar-today"
                  :readonly="false"
                >
                </b-datepicker>
              </b-field>
            </div>

            <div class="column">
              <b-field label="Hasta">
                <b-datepicker
                  v-model="dateTo"
                  :min-date="dateFrom"
                  placeholder="Ingresa el segundo rango"
                  icon="calendar-today"
                  :readonly="false"
                >
                </b-datepicker>
              </b-field>
            </div>

            <div class="column">
              <b-field label="Estado">
                <b-select
                  v-model="estado"
                  placeholder="Selecciona un canal"
                  expanded
                >
                  <option value="TODOS">Todos</option>
                  <option value="pen">Pendientes</option>
                  <option value="env">Enviados</option>
                  <option value="recep">Recepcionado</option>
                  <option value="can">Cancelados</option>
                </b-select>
              </b-field>
            </div>
          </div>
          <div class="center">
            <button
              :disabled="!validateFilters"
              @click="consultarOrderMaterial"
              class="button is-success is-rounded"
            >
              Consultar
            </button>
          </div>

          <div
            class="btn-export report"
            v-show="materiales.length > 0"
          >
            <div>
              <button @click="exportarOrderMaterial" class="button is-small">
                <b-icon icon="file-excel" class="colour-excel"></b-icon>
                <span style="font-weight: bold"> Descargar Excel </span>
              </button>
            </div>
          </div>

          <section>
            <b-table
              :data="materiales"
              paginated
              :per-page="searchOptions.perPage"

            >
              <template slot-scope="props">
                <b-table-column label="Responsable" class="is-size-7">
                  {{ props.row.userName }}
                </b-table-column>

                <b-table-column label="Tipo Material" class="is-size-7">
                  {{ props.row.name }}
                </b-table-column>

                <b-table-column label="Fecha Orden" class="is-size-7">
                  {{ new Date(props.row.orderDate) | moment("DD-MM-YYYY") }}
                </b-table-column>

                <b-table-column label="N° Orden" class="is-size-7">
                  {{ props.row.numberOrder }}
                </b-table-column>

                <b-table-column label="Cantidad" class="is-size-7">
                  {{ props.row.cantidad }}
                </b-table-column>

                <b-table-column label="Descripción" class="is-size-7">
                  {{ props.row.description }}
                </b-table-column>

                <b-table-column label="Observación" class="is-size-7">
                  {{ props.row.observation }}
                </b-table-column>

                <b-table-column label="N° Código Barras" class="is-size-7">
                  {{ props.row.code }}
                </b-table-column>

                <b-table-column label="Código Dirección" class="is-size-7">
                {{ props.row.addressCode}}
               </b-table-column>

               <b-table-column label="Dirección" class="is-size-7">
                {{ props.row.addressName}}
               </b-table-column>

                <b-table-column label="Estado" class="is-size-7">
                  <b-tag :type="getClassStatusOrder(props.row.status)">{{
                    props.row.status | StatusOrderConvert
                  }}</b-tag>
                </b-table-column>
              </template>


              <template slot="empty">
                <section class="section">
                  <div class="content has-text-grey has-text-centered">
                    <p>
                      <b-icon icon="emoticon-sad" size="is-large"> </b-icon>
                    </p>
                    <p>No hay resultados.</p>
                  </div>
                </section>
              </template>
            </b-table>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Util from "../../../util";
import { mapActions, mapGetters, mapMutations } from "vuex";
import ReporteItemMateriales from "../../../api/modules/ReporteItemMateriales";

export default {
  data() {
    return {
      searchOptions: {
        perPage: 10,
        pageNumber: 1,
      },
      estado: "TODOS",
      dateFrom: null,
      dateTo: null,
      orderMateriales: [],
      address: "TODOS",
      materiales: [],
    };
  },
  methods: {
    onPageChange(page) {
      this.searchOptions.pageNumber = page;
      this.consultarOrderMaterial();
    },

    consultarOrderMaterial() {
       this.materiales = [];
      var paramsArray = [
        `pageNumber=${this.searchOptions.pageNumber}`,
        `perPage=${this.searchOptions.perPage}`,
        `fechaInicio=${this.dateFrom}`,
        `fechaFin=${this.dateTo}`,
      ];

      if (this.estado != "TODOS") {
        paramsArray.push(`estado=${this.estado}`);
      }

      const params = paramsArray.join("&");

      return new Promise((resolve, reject) => {
        ReporteItemMateriales.getOrderMateriales(this, {
          idClient: this.getClient.id,
          idAddress: Util.getUser().idAddress,
          param: params,
        })
          .then((data) => {
            this.orderMateriales = data;
            let orderMaterial = this.orderMateriales;
            orderMaterial.forEach((item) => {
              let materialesTmp = item.materiales;
              materialesTmp.forEach((m) => {
                 if (m.name === "VALIJA") {
                  m.numberOrder = item.numberOrder;
                  m.status = item.status;
                  m.userName = item.userName;
                  m.orderDate = item.orderDate;
                  m.addressCode= item.address.code
                  m.addressName= item.address.name
                  this.materiales.push(m);
                 }
              });
            });

            resolve(data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    exportarOrderMaterial() {
      var paramsArray = [
        `fechaInicio=${this.dateFrom}`,
        `fechaFin=${this.dateTo}`,
      ];
      if (this.estado != "TODOS") {
        paramsArray.push(`estado=${this.estado}`);
      }

      const params = paramsArray.join("&");
      ReporteItemMateriales.dowloandGetOrderMateriales(this, {
        idClient: this.getClient.id,
        idAddress: Util.getUser().idAddress,
        param: params,
      }).then();
    },

    getClassStatusOrder(value) {
      if (!value) return "";
      if (value === "pen" || value === "envobs" || value === "entobs")
        return "is-warning";
      else if (value === "apr" || value === "env") return "is-info";
      else if (value === "recep") return "is-success";
      else if (value === "can") return "is-danger";
      else return "";
    },
  },

  computed: {
    ...mapGetters({
      getClient: "auth/getClient",
    }),

    validateFilters() {
      return this.dateTo != null && this.dateFrom != null;
    },
  },
};
</script>
<style scoped>
.report {
  margin-top: 30px;
}
.center {
  text-align: center;
}
.btn-export {
  text-align: right;
  margin-bottom: 0.25rem;
}
.break-word {
  word-break: break-all;
}
.colour-pdf {
  color: red;
}
.colour-excel {
  color: green;
}
</style>



// WEBPACK FOOTER //
// src/components/reportes/materiales/EstadoMateriales.vue